<template>
	<div class="app-container">
		<SidebarNavigation :is-showing-homepage="user.hasAccessToHomepage" />
		<main class="app-container__main">
			<app-header
				:title="pageTitle"
				:user-name="userName"
				:user-email="userEmail"
				:logout-label="$t('globals.logout')"
				@logout="keycloak.logout()"
			/>
			<router-view />
		</main>
	</div>
</template>

<script setup lang="ts">
import { ref, watch, watchEffect, onMounted, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import UsersStore from '@apps/dashboard/src/store/usersStore';
import SidebarNavigation from '@shared/components/SidebarNavigation.vue';
import { AppHeader } from '@ds/components';

const keycloak = getCurrentInstance()?.appContext.config.globalProperties.$keycloak;

const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const { user } = UsersStore();

const pageTitle = ref();
const userName = ref('admin');
const userEmail = ref('');

watch(user, () => {
	if (!user.isAuthenticated) {
		router.push({ name: 'unauthorised' });
	}
});

watchEffect(() => {
	pageTitle.value = t(`routes.${route.meta.title}`);
});

onMounted(() => {
	if (user.preferredName) userName.value = user.preferredName;
	if (user.email) userEmail.value = user.email;
});
</script>

<style lang="scss" scoped>
.app-container {
	height: 100vh;
	width: 100vw;
	overflow: hidden;

	display: grid;
	grid-template-columns: auto 1fr;
	grid-template-areas: 'nav-bar main-view';

	&__main {
		grid-area: main-view;
		overflow: hidden;
		position: relative; // Loader has position absolute
		background-color: $color-neutral-50;
	}
}
</style>
